export default "__VITE_ASSET__RhwMN4mn__"